import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {AuthenticationService} from '../core/services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class ExportGuard implements CanActivate {

  constructor(private authenticationService: AuthenticationService, public router: Router) {
  }

  canActivate(): boolean {
    const user = this.authenticationService.currentUserValue;
    if (!user) {
      console.log('ExportGuard - User not authenticated.');
      this.router.navigate(['/login']);
      return false;
    }
    const allow = ('ADMN' === user.roleTypeCode || 'OPRTN' === user.roleTypeCode);
    if (!allow) {
      console.log('ExportGuard - User lacks permission to requested page.');
    }
    return allow;
  }
}
